// extracted by mini-css-extract-plugin
export default {"button-agp":"styles_button-agp__-boSb","button-agp-strong":"styles_button-agp-strong__59fTv"};